var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('coverage-page',{attrs:{"customPageControl":_vm.pageControl,"customNeedValidate":_vm.needValidate}})}
var staticRenderFns = []

export { render, staticRenderFns }